/**
 * Password Policy & Complexity Verification Utility
 * Centralized rule-checking matching backend enterprise standards:
 * - Minimum 12 characters
 * - At least 1 number & 1 special character
 * - No sequential alphabet/numeric (e.g., '123', 'abc') or QWERTY keyboard patterns
 */

export const SPECIAL_PATTERN = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/

export function hasSequentialPattern(password) {
  const normalized = String(password || '').toLowerCase()
  for (let index = 0; index < normalized.length - 2; index += 1) {
    const c1 = normalized.charCodeAt(index)
    const c2 = normalized.charCodeAt(index + 1)
    const c3 = normalized.charCodeAt(index + 2)
    if ((c2 === c1 + 1 && c3 === c2 + 1) || (c2 === c1 - 1 && c3 === c2 - 1)) {
      return true
    }
  }

  const keyboardPatterns = [
    'qwe',
    'wer',
    'ert',
    'rty',
    'tyu',
    'yui',
    'uio',
    'iop',
    'asd',
    'sdf',
    'dfg',
    'fgh',
    'ghj',
    'hjk',
    'jkl',
    'zxc',
    'xcv',
    'cvb',
    'vbn',
    'bnm',
  ]
  return keyboardPatterns.some((pattern) => normalized.includes(pattern))
}

export function evaluatePasswordComplexity(password) {
  const normalized = String(password || '')
  const minLength = normalized.length >= 12
  const hasSpecialAndNumber = SPECIAL_PATTERN.test(normalized) && /\d/.test(normalized)
  const noSequential = normalized.length > 0 && !hasSequentialPattern(normalized)
  const isMet = minLength && hasSpecialAndNumber && noSequential

  return {
    minLength,
    hasSpecialAndNumber,
    noSequential,
    isMet,
  }
}
